
import axios from "axios"


// API function in addition to handle multiple header status, and to handle meta code
export const handleApiCall = (method, url, params, successHandler, onSuccessView, onFailedView) => {


  axios({
    method: method,
    url: url,
    responseType: 'json',
    data: params,
    withCredentials: false,
    headers: {'Access-Control-Allow-Origin': '*'}
  })
    .then(function (responseJSON) {
      // const responseJSON = await axios.post(url, params)
      //first layer status code handling
      if ((responseJSON.status === 204) || (responseJSON.status === 200)) {
        if ((responseJSON.status === 204) || (responseJSON.data.meta.code === 200)) {
          successHandler(responseJSON)
          onSuccessView(responseJSON.data.data)
        } else {

          onFailedView(responseJSON.data.meta.message)

        }

      } else {
        //failed

        onFailedView("Terjadi Kesalahan")
      }


    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        console.log("error data : " + error.response.data);
        console.log("error status : " + error.response.status);
        console.log("error headers : " + error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("error requestnya = " + error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      onFailedView("Terjadi Kesalahan")

      return false

    })


}
